import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange, totalItems, pageSize }) => {
  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible + 2) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      let start = Math.max(2, currentPage - 1);
      let end = Math.min(totalPages - 1, currentPage + 1);

      if (currentPage <= 3) {
        start = 2;
        end = Math.min(maxVisible, totalPages - 1);
      } else if (currentPage >= totalPages - 2) {
        start = Math.max(2, totalPages - maxVisible + 1);
        end = totalPages - 1;
      }

      if (start > 2) pages.push("...");
      for (let i = start; i <= end; i++) pages.push(i);
      if (end < totalPages - 1) pages.push("...");
      pages.push(totalPages);
    }
    return pages;
  };

  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalItems);

  const btnStyle = (active) => ({
    padding: "6px 10px",
    minWidth: "32px",
    border: active ? "1px solid var(--color-highlight)" : "1px solid var(--border-subtle)",
    borderRadius: "6px",
    background: active ? "var(--color-highlight)" : "transparent",
    color: active ? "#fff" : "var(--text-secondary)",
    cursor: active ? "default" : "pointer",
    fontSize: "13px",
    fontWeight: active ? "600" : "400",
    transition: "all 0.15s",
  });

  const arrowStyle = (disabled) => ({
    ...btnStyle(false),
    opacity: disabled ? 0.3 : 1,
    cursor: disabled ? "not-allowed" : "pointer",
  });

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "12px 16px",
        borderTop: "1px solid var(--border-subtle)",
        flexWrap: "wrap",
        gap: "8px",
      }}
    >
      <span style={{ fontSize: "12px", color: "var(--text-muted)" }}>
        Showing {startItem}–{endItem} of {totalItems}
      </span>
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <button
          style={arrowStyle(currentPage === 1)}
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          ‹
        </button>
        {getPageNumbers().map((page, i) =>
          page === "..." ? (
            <span key={`dots-${i}`} style={{ padding: "0 4px", color: "var(--text-muted)", fontSize: "13px" }}>
              …
            </span>
          ) : (
            <button
              key={page}
              style={btnStyle(page === currentPage)}
              onClick={() => page !== currentPage && onPageChange(page)}
            >
              {page}
            </button>
          )
        )}
        <button
          style={arrowStyle(currentPage === totalPages)}
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          ›
        </button>
      </div>
    </div>
  );
};

export default Pagination;
